"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var typography_1 = require("../../typography");
var styles_1 = require("./styles");
var LEVEL = {
    '1': '2',
    '2': '3',
    '3': '4',
};
var Button = function (_a) {
    var children = _a.children, href = _a.href, _b = _a.isExternal, isExternal = _b === void 0 ? false : _b, onClick = _a.onClick, _c = _a.type, type = _c === void 0 ? 'button' : _c, _d = _a.disabled, disabled = _d === void 0 ? false : _d, fullWidth = _a.fullWidth, _e = _a.version, version = _e === void 0 ? 'filled' : _e, _f = _a.level, level = _f === void 0 ? '2' : _f, commonProps = __rest(_a, ["children", "href", "isExternal", "onClick", "type", "disabled", "fullWidth", "version", "level"]);
    if (typeof href === 'string') {
        return (react_1.default.createElement(styles_1.LinkWrapper, __assign({ "data-component-name": "Button" }, commonProps, { href: href, disabled: disabled, "$fullWidth": fullWidth, "$version": version, "$level": level, onClick: onClick, isExternal: isExternal }),
            react_1.default.createElement(typography_1.Body, { level: LEVEL[level], as: "div" }, children)));
    }
    return (react_1.default.createElement(styles_1.ButtonWrapper, __assign({ "data-component-name": "Button" }, commonProps, { disabled: disabled, "$fullWidth": fullWidth, "$version": version, "$level": level, onClick: onClick, type: type }),
        react_1.default.createElement(typography_1.Body, { level: LEVEL[level], as: "div" }, children)));
};
exports.default = Button;
